'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
var words = require('./words.js');
function upperCase(str) {
    var words$1 = words.words(str);
    var result = '';
    for(var i = 0; i < words$1.length; i++){
        result += words$1[i].toUpperCase();
        if (i < words$1.length - 1) {
            result += ' ';
        }
    }
    return result;
}
exports.upperCase = upperCase;
